'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Divider = require('@narvar/nth-bit-divider');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ClaimSummarySectionHeaderRoot = styled__default["default"].div.withConfig({
  componentId: "sc-9enl1c-0"
})(["margin-bottom:1rem;"]);
const ClaimSummarySectionHeader = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(ClaimSummarySectionHeaderRoot, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    containerCustomStyle: {
      marginBottom: '0.5rem'
    }
  }, children), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null));
};

exports["default"] = ClaimSummarySectionHeader;
